module.exports = __webpack_public_path__ + "static/media/logo1.d67e17f6.jpg";